import { Icon, Text, Title, XStack, YStack } from '@frontend/web-react';
import type { ReactNode } from 'react';

type OnboardingCardProps = {
  children: ReactNode;
  description?: string;
  onBack?: () => void;
  title?: string;
};
export const OnboardingCard = ({ children, description, onBack, title }: OnboardingCardProps) => {
  const hasHeader = title || description || onBack;
  return (
    <YStack bg="white" borderColor="neutral200" borderWidth={1} className="w-full p-md lg:p-xl" gapY="lg" radius="xl">
      {hasHeader ? (
        <>
          <XStack className="justify-between" gap="sm">
            <YStack className="size-xl">
              {onBack ? <Icon name="IconArrowLeft" onClick={onBack} size={24} /> : null}
            </YStack>
            {title ? (
              <YStack gapY="sm">
                <Title textAlign="center" type="h3">
                  {title}
                </Title>
              </YStack>
            ) : null}
            <YStack className="size-xl" />
          </XStack>
          {description ? (
            <YStack>
              <Text color="tertiary" textAlign="center" type="p-sm">
                {description}
              </Text>
            </YStack>
          ) : null}
        </>
      ) : null}
      {children}
    </YStack>
  );
};
